import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-6" }
const _hoisted_2 = { class: "v-col-6 pr-0" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "font-size-12-600 font-black pr-3" }
const _hoisted_5 = { class: "v-col-6 pr-0" }
const _hoisted_6 = { class: "d-flex align-center" }

import {ref, reactive, watch, computed} from 'vue';
import TextArea from "@/components/custom/TextArea.vue";
import SelectDropdown from "@/components/custom/SelectDropdown.vue";
import FlexContainer from "@/views/ClientComponents/MedicalAlerts/Partials/FlexContainer.vue";
import DatePicker from "@/components/custom/DatePicker.vue";
import moment from "moment";
import RotatingArrow from "@/components/custom/RotatingArrow.vue";
import ErrorMessages from "@/components/custom/ErrorMessages.vue";
import {statusTypes, medicalAlertTypes} from "@/views/ClientComponents/MedicalAlerts/Helpers";
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MedicalAlertForm',
  props: {
  modelValue: {
    type: Object,
  },

  variant: {
    type: String,
  },

  disabledSelect: {
    type: Boolean,
    default: false,
  },

  readonlySelect: {
    type: Boolean,
    default: false,
  },

  errors: {
    type: Object,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const route = useRoute();

const emit = __emit

const props = __props

const setForm = ref({...props.modelValue});
const rotateArrowDateFrom = ref(false);
const rotateArrowDateTo = ref(false);

watch(() => props.modelValue, (val) => {
  setForm.value = val
})

watch(setForm, (newValue) => {
  rotateArrowDateFrom.value = false;
  rotateArrowDateTo.value = false;

  if (newValue.status === 'Ongoing') {
    newValue.date_to = null;
  }

  if (newValue.status === 'Ended' && !newValue.date_to) {
    newValue.date_to = moment().format('YYYY-MM-DD');
  }

  emit('update:modelValue', newValue);
}, {deep: true});

const formattedDate = (value: string | number, format = 'YYYY-MM-DD') => {
  return moment(value).format(format)
}

const minDateFrom = computed(() => {
  return route.query.dob ? route.query.dob : null
})

const minDateTo = computed(() => {
  return setForm.value.date_to ? formattedDate(setForm.value.date_from) : null
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      placeholder: "Name",
      density: "compact",
      class: "pt-3 pb-5",
      width: "100%",
      variant: "solo",
      elevation: "0",
      "hide-details": "",
      modelValue: setForm.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setForm.value.name) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "name"
    }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TextArea, {
        modelValue: setForm.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((setForm.value.description) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "description"
    }, null, 8, ["errors"]),
    _createVNode(FlexContainer, { title: "Type" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SelectDropdown, {
            modelValue: setForm.value.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((setForm.value.type) = $event)),
            items: _unref(medicalAlertTypes),
            variant: __props.variant,
            disabled: __props.disabledSelect,
            readonly: __props.readonlySelect
          }, null, 8, ["modelValue", "items", "variant", "disabled", "readonly"])
        ])
      ]),
      _: 1
    }),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "type"
    }, null, 8, ["errors"]),
    _createVNode(_component_v_divider),
    _createVNode(FlexContainer, { title: "Date From" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(formattedDate(setForm.value.date_from, 'DD MMM YYYY')), 1),
          _createVNode(RotatingArrow, { "rotate-arrow": rotateArrowDateFrom.value }, null, 8, ["rotate-arrow"]),
          _createVNode(DatePicker, {
            class: "date-calendar-input",
            modelValue: setForm.value.date_from,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setForm.value.date_from) = $event)),
            min: minDateFrom.value,
            max: _unref(moment)().format('YYYY-MM-DD'),
            onBlur: _cache[4] || (_cache[4] = ($event: any) => (rotateArrowDateFrom.value = false)),
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (rotateArrowDateFrom.value = true))
          }, null, 8, ["modelValue", "min", "max"])
        ])
      ]),
      _: 1
    }),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "date_from"
    }, null, 8, ["errors"]),
    _createVNode(_component_v_divider),
    _createVNode(FlexContainer, { title: "Status" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SelectDropdown, {
            modelValue: setForm.value.status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((setForm.value.status) = $event)),
            items: _unref(statusTypes),
            variant: __props.variant,
            disabled: __props.disabledSelect,
            readonly: __props.readonlySelect
          }, null, 8, ["modelValue", "items", "variant", "disabled", "readonly"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider),
    _createVNode(FlexContainer, { title: "Date To" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass(["font-size-12-600 font-black pr-3", {'font-grey': setForm.value.status === 'Ongoing' }])
          }, _toDisplayString(setForm.value.status === 'Ongoing' ? 'Present' : formattedDate(setForm.value.date_to, 'DD MMM YYYY')), 3),
          (setForm.value.status === 'Ended')
            ? (_openBlock(), _createBlock(RotatingArrow, {
                key: 0,
                "rotate-arrow": rotateArrowDateTo.value
              }, null, 8, ["rotate-arrow"]))
            : _createCommentVNode("", true),
          _createVNode(DatePicker, {
            class: "date-calendar-input",
            modelValue: setForm.value.date_to,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((setForm.value.date_to) = $event)),
            min: minDateTo.value,
            max: _unref(moment)().format('YYYY-MM-DD'),
            disabled: setForm.value.status === 'Ongoing',
            onBlur: _cache[8] || (_cache[8] = ($event: any) => (rotateArrowDateTo.value = false)),
            onFocus: _cache[9] || (_cache[9] = ($event: any) => (rotateArrowDateTo.value = true))
          }, null, 8, ["modelValue", "min", "max", "disabled"])
        ])
      ]),
      _: 1
    }),
    _createVNode(ErrorMessages, {
      errors: __props.errors,
      name: "date_to"
    }, null, 8, ["errors"]),
    _createVNode(_component_v_divider)
  ], 64))
}
}

})